import {
  FDDialog,
} from '@facet-wealth/design';
import React from 'react';
import { useModalContext } from 'Views/Page/Contexts/ModalContext';
import useMobileLayout from 'Hooks/useMobileLayout';
import PropTypes from 'prop-types';
import ModalForm2 from 'Views/Page/Content/Modal/Components/ModalForm2';
import { LottieLoadingLayout } from 'Components/ComponentLibrary/Organisms/LottieControl/LottieLoadingLayout';
import { dataAttrs } from 'Helpers/Testing';


export const CelebrationDialog = ({
  Layout,
  metaOverrideSet,
  modalSize,
  fixedHeight,
  noCloseButton,
}) => {
  const {
    modalCollection,
    clearModalCollection,
  } = useModalContext();
  const isMobile = useMobileLayout();

  return (
    <LottieLoadingLayout>
      <FDDialog
        {...dataAttrs('celebration-dialog', modalCollection?.resources()?.head())}
        onClose={() => {
          clearModalCollection();
        }}
        dialogWidth={modalSize}
        fixedHeight={fixedHeight}
        fullScreen={isMobile}
        open={!!modalCollection}
        color="emphasized"
        noCloseButton={noCloseButton}
      >
        <ModalForm2
          Layout={Layout}
          metaOverrideSet={metaOverrideSet}
        />
      </FDDialog>
    </LottieLoadingLayout>

  );
};

CelebrationDialog.defaultProps = {
  fixedHeight: true,
  noCloseButton: false,
};

CelebrationDialog.propTypes = {
  Layout: PropTypes.func.isRequired,
  metaOverrideSet: PropTypes.object.isRequired,
  modalSize: PropTypes.string.isRequired,
  fixedHeight: PropTypes.bool,
  noCloseButton: PropTypes.bool,
};
